<template>
  <div class="checkSku">
    <el-dialog
      width="600px"
      title="选择班级"
      :visible.sync="innerVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body>
        <div>
          班级名称 <el-input size="small" v-model="filter.skuName" placeholder="请输入" style="width: 200px"></el-input>
          <el-button type="primary" size="small" style="margin-left: 20px" @click="search">搜索</el-button>
          <el-button type="" size="small" @click="reset">重置</el-button>
        </div>
        <el-table
          ref="skuTable"
          :data="list"
          border
          style="margin-top: 10px"
          @selection-change="handleSelectionChange"
          row-key="id">
          <el-table-column align="center" type="selection" width="55" :reserve-selection="true"></el-table-column>
          <el-table-column align="center" label="班级ID" prop="id" width="170"></el-table-column>
          <el-table-column align="center" label="班级名称" prop="skuName"></el-table-column>
        </el-table>
        <el-pagination
          style="margin-top: 10px; text-align: center;"
          :current-page="filter.page"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="filter.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
        <span slot="footer" class="dialog-footer">
          <span class="selected-tip">已选 {{ selectedList.length }} 个班级</span>
          <el-button @click="cancel">取 消</el-button>
          <el-button type="primary" @click="confirm">确 定</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
import { getPageList } from '@/api/product/classManage'
export default {
  name: 'CheckSku',
  data () {
    return {
      innerVisible: false,
      filter: {
        page: 1,
        limit: 10,
        courseType: 2,
        skuName: ''
      },
      list: [],
      total: 0,
      selectedList: []
    }
  },
  methods: {
    init(selected = []) {
      this.selectedList = []
      this.innerVisible = true
      this.getList().then(() => {
        // 编辑时回显已选班级
        if (selected && selected.length) {
          this.$nextTick(() => {
            selected.forEach(row => {
              const exists = this.list.find(item => item.id === row.skuId || item.id === row.id)
              if (exists) {
                this.$refs.skuTable.toggleRowSelection(exists, true)
              }
            })
            // 处理跨页已选：把不在当前页的也保留在 selectedList
            this.selectedList = selected.map(row => ({
              id: row.skuId || row.id,
              skuName: row.skuName
            }))
          })
        }
      })
    },
    async getList() {
      const res = await getPageList(this.filter)
      this.list = res.data.records
      this.total = +res.data.total
    },
    handleSelectionChange(rows) {
      // 当前页选中的
      const currentPageIds = this.list.map(item => item.id)
      // 移除当前页中未选中的
      this.selectedList = this.selectedList.filter(
        item => !currentPageIds.includes(item.id)
      )
      // 合并当前页选中的
      rows.forEach(row => {
        if (!this.selectedList.find(item => item.id === row.id)) {
          this.selectedList.push({ id: row.id, skuName: row.skuName })
        }
      })
    },
    confirm() {
      if (this.selectedList.length === 0) {
        return this.$message.warning('请至少选择一个班级')
      }
      this.$emit('check', this.selectedList)
      this.innerVisible = false
    },
    cancel() {
      this.innerVisible = false
    },
    // 搜索
    search() {
      this.filter.page = 1
      this.getList()
    },
    // 重置
    reset() {
      Object.keys(this.filter).forEach(key => {
        this.filter[key] = null
      })
      this.filter.page = 1
      this.filter.limit = 10
      this.filter.courseType = 2
      this.getList()
    },
    handleSizeChange(v) {
      this.filter.page = 1
      this.filter.limit = v
      this.getList()
    },
    handleCurrentChange(v) {
      this.filter.page = v
      this.getList()
    },
  }
}
</script>

<style lang="scss" scoped>
.checkSku {
  .selected-tip {
    float: left;
    line-height: 32px;
    color: #606266;
  }
}
</style>
